<div class="alert-loading">
  <div class="alert-loading-content">
    <img src="https://static.twonas.com/apps/misc/spinner-default.svg" />
  </div>
</div>
